import * as actionsTypes from './actionsTypes';

const initialState = {
  surveyResults: [],
  isLoading: false,
  error: "",
}

export default function surveyResultsReducer(state = initialState, action){
  switch (action.type) {
    case actionsTypes.FETCH_SURVEY_RESULTS_REQUEST:
      return {...state, isLoading: action.payload}
    case actionsTypes.FETCH_SURVEY_RESULTS_SUCCESS:
      return {...state, surveyResults: action.payload};
    case actionsTypes.FETCH_SURVEY_RESULTS_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}